module.exports = __webpack_public_path__ + "img/1.556def57.jpg";